import { render, staticRenderFns } from "./Privacidade.vue?vue&type=template&id=5aa95912&"
import script from "./Privacidade.vue?vue&type=script&lang=js&"
export * from "./Privacidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports